import {titleCase} from 'title-case'

export function capitalize(str) {
  return titleCase(str)
}

export function capitalizeSentences(str) {
  // capitalize first word of each sentence
  return str.replace(/(?<=(?:[.?!]\s|^)\W*)[a-z]/g, i => i.toUpperCase())
}

export function join(array, options = {}) {
  if (!Array.isArray(array) || array.length === 0) {
    return 'No items'
  }

  let items = [...array]
  
  if (options.uppercase) {
    items = items.map(item => item.toUpperCase())
  }

  if (options.capitalize) {
    items = items.map(item => capitalize(item))
  }

  if (items.length === 1) {
    return items[0]
  }

  const last = items.pop() 
  const joined = items.join(', ')

  return `${joined} or ${last}`
}

export function trim_to(value, len) {
  if (!len || !value || value.length <= len) {
    return value
  }
  return `${value.substr(0, len-3)}...`
}

export function nthIndexOf(str, search, n) {
  let index = str.indexOf(search)
  while (n-- > 0 && index !== -1) {
    index = str.indexOf(search, index + 1)
  }
  return index
}

export function decodeHTMLEntities(html) {
  if (!html) return html
  const textarea = document.createElement('textarea')
  textarea.innerHTML = html
  return textarea.value.replaceAll('\n', '')
}

export function getRootDomain(url){
  let result
  const match = url.match(/^(?:https?:\/\/)?(?:[^@\n]+@)?(?:www\.)?([^:\\/\n\\?\\=]+)/im)
  if (match) {
    result = match[1]
    if (result.match(/^[^\\.]+\.(.+\..+)$/)) {
      result = match[1]
    }
  }
  return result
}

export function truncate(str, num){
  if (str.length > num) {
    return str.slice(0, num) + '...'
  } else {
    return str
  }
}


export function pluralize(count, singular, plural = null) {
  if (count === 1) return `${count} ${singular}`
  return `${count} ${plural || singular + 's'}`
}

export function escapeRawString(str) {
  return str
    .replace(/\\/g, '\\\\')
    .replace(/\n/g, '\\n')
    .replace(/\r/g, '\\r')
    .replace(/\t/g, '\\t')
}